import AutosaveField from 'components/crm/ui/AutosaveField';
import TextField from 'components/crm/ui/TextField';
import useText from 'hooks/useText';

const FIELD_ID = 'task-description';
// The api refuses a longer note (INVALID_TASK_FIELD).
const MAX_LENGTH = 5000;

// The description of the task, written in place (saved on leaving the field,
// on changing tab and on closing), or only read by whoever may not edit it.
const TaskDescriptionField = ({ initial, onSave, canEdit = true }) => {
  const { text } = useText('taskPanel');
  if (!canEdit) {
    return (
      <TextField
        id={FIELD_ID}
        label={text('descriptionLabel')}
        multiline
        rows={3}
        value={initial}
        placeholder={text('descriptionPlaceholder')}
        disabled
        readOnly
      />
    );
  }
  return (
    <AutosaveField
      id={FIELD_ID}
      label={text('descriptionLabel')}
      placeholder={text('descriptionPlaceholder')}
      initial={initial}
      maxLength={MAX_LENGTH}
      onSave={onSave}
    />
  );
};

export default TaskDescriptionField;
